import { EMobileLayoutActiveSide } from '../../types/mobileSide';
import { ITypedReduxAction } from '../../types/redux/actionType';

export enum EMobileActiveSideTypes {
  SetActive = 'mobileSide/setActive',
}

export type TMobileActiveSideActions = ITypedReduxAction<EMobileActiveSideTypes.SetActive, EMobileLayoutActiveSide>;
